import { render, staticRenderFns } from "./CmaAssetInfoPanel.vue?vue&type=template&id=93c03ff0&scoped=true&"
import script from "./CmaAssetInfoPanel.vue?vue&type=script&lang=js&"
export * from "./CmaAssetInfoPanel.vue?vue&type=script&lang=js&"
import style0 from "./CmaAssetInfoPanel.vue?vue&type=style&index=0&id=93c03ff0&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93c03ff0",
  null
  
)

export default component.exports